import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApiAdmin from "./useApiAdmin";

const useEditAdminUser = () => {
  const { editAdminUser } = useApiAdmin();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      token,
      userId,
      adminValue,
    }: {
      token: string;
      userId: string;
      adminValue: boolean;
    }) => editAdminUser(token, userId, adminValue),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
  });
};

export default useEditAdminUser;
